import {api} from '../../utils/api'
import store from "../store";

export default {

    /**
     * load messaged
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    loadMessages({commit}, payload) {
        let limit = payload.limit ? '/' + payload.limit : ''
        return api.call(commit, 'get', process.env.VUE_APP_MESSENGER_URL+'/api/message/'+payload.discussion_id + limit, null,  'SET_MESSAGES');
    },

    /**
     * Clear history
     * @param commit
     * @param discussion_id
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    clearHistory({commit}, discussion_id) {
        return api.call(commit, 'delete', process.env.VUE_APP_MESSENGER_URL+'/api/message/'+discussion_id + "/clear", null, 'SET_MESSAGES');
    },

    /**
     * load messages
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    loadAttachments({commit}, id) {
        return api.call(commit, 'get', process.env.VUE_APP_MESSENGER_URL+`/api/discussion/${id}/attachments`, false,  'SET_ATTACHMENTS');
    },


    /**
     * Remove message
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    removeAttachment({commit}, id) {
        return api.call(commit, 'delete', process.env.VUE_APP_MESSENGER_URL+'/api/message/attachment/'+id, null, 'SET_ATTACHMENTS');
    },

    /**
     * Send message
     * @param commit
     * @param discussion_id
     * @param id
     * @param message
     * @param attachments
     * @returns {*|Promise|Promise<any>}
     */
    sendMessage({commit}, {discussion_id, message, attachments}) {

        // Get current active user
        let sender_id = store.getters['auth/currentUser'].id;

        // Send message
        return api.call(commit, 'post', process.env.VUE_APP_MESSENGER_URL+'/api/message/'+discussion_id, {message, sender_id, attachments},  'SET_MESSAGES');
    },

    /**
     * Send message
     * @param commit
     * @param discussion_id
     * @param id
     * @param message
     * @param attachments
     * @returns {*|Promise|Promise<any>}
     */
    updateMessage({commit}, {id, message}) {

        // Get current active user
        let sender_id = store.getters['auth/currentUser'].id;

        // Send message
        return api.call(commit, 'patch', process.env.VUE_APP_MESSENGER_URL+'/api/message/' + id, {message, sender_id},  'SET_MESSAGES');
    },

    /**
     * Remove message
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    removeMessage({commit}, id) {
        return api.call(commit, 'delete', process.env.VUE_APP_MESSENGER_URL+'/api/message/'+id, null, 'SET_MESSAGES');
    },

    /**
     * load discussions
     * @param commit
     * @param parent_type
     * @param parent_id
     * @returns {*|Promise|Promise<any>}
     */
    loadDiscussions({commit}, {parent_type, parent_id}) {
        return api.call(commit, 'get', process.env.VUE_APP_MESSENGER_URL+'/api/discussion/'+parent_type+"/"+parent_id, null,  'SET_DISCUSSIONS');
    },

    /**
     * Create discussion
     * @param commit
     * @param id
     * @param message
     * @returns {*|Promise|Promise<any>}
     */
    createDiscussion({commit}, {parent_type, parent_id, type, title, users, sub_id}) {
        return api.call(commit, 'post', process.env.VUE_APP_MESSENGER_URL+'/api/discussion',  {parent_type, parent_id, type, title, users, sub_id},  'SET_DISCUSSIONS');
    },

    /**
     * Update discussion
     * @param commit
     * @param id
     * @param message
     * @returns {*|Promise|Promise<any>}
     */
    updateDiscussion({commit}, {id, title, users}) {
        return api.call(commit, 'patch', process.env.VUE_APP_MESSENGER_URL+'/api/discussion/'+id,  {title, users},  'SET_DISCUSSIONS');
    },

    /**
     * Archive discussion
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    archiveDiscussion({commit}, id) {
        return api.call(commit, 'post', process.env.VUE_APP_MESSENGER_URL+'/api/discussion/'+id+'/archive', null, 'SET_DISCUSSIONS');
    },

    /**
     * Remove discussion
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    removeDiscussion({commit}, id) {
        return api.call(commit, 'delete', process.env.VUE_APP_MESSENGER_URL+'/api/discussion/'+id, null, 'SET_DISCUSSIONS');
    },
}
